import React, { FC, useRef, useState } from 'react';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import { FeedItemStats } from './interfaces/feedItemStats.interface';
import { FeedItemVisibilityWrapperProps } from './props';
import './styles.scss';

export const FeedItemVisibilityWrapper: FC<FeedItemVisibilityWrapperProps> = ({ wrapperClassName, children }) => {
  const feedItemHeight = useRef<HTMLDivElement | null>(null);
  const [feedItem, setFeedItem] = useState<FeedItemStats>({
    height: 'inherit',
    isVisible: true,
  });

  return (
    <VisibilitySensor
      offset={{
        bottom: -500,
        top: -500,
      }}
      onChange={isVisible => {
        if (feedItemHeight.current && feedItemHeight.current.clientHeight) {
          if (isVisible) {
            setFeedItem({
              height: 'inherit',
              isVisible: isVisible,
            });
          } else {
            setFeedItem({
              height: feedItemHeight.current.clientHeight,
              isVisible: isVisible,
            });
          }
        }
      }}
      partialVisibility
    >
      <div
        className={classnames('feed-item-visibility-wrapper', wrapperClassName)}
        ref={feedItemHeight}
        style={{ height: feedItem.height }}
      >
        {feedItem.isVisible && children}
      </div>
    </VisibilitySensor>
  );
};
